module.exports = __webpack_public_path__ + "static/media/2025_Nalik_Venture.945ce77b.png";